/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-18T11:02:58-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T08:57:16-07:00
*/



import React, { Component } from 'react';
import Checkbox from '../../common/Checkbox';
import InputGroup from '../../blocks/InputGroup';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import Container from '../../blocks/Container';


class ManagePrivacy extends Component {

  render() {
    let { settings, updateAccountSetting } = this.props;
    return (
      <div>
        <Header>
          <Headline>Privacy</Headline>
        </Header>
          <Container spacedBottom>
            <InputGroup vertical>
              <Checkbox value={settings.hidden} id="hidden" onChange={updateAccountSetting} label="Hide my profile from showing in search" />
              <Checkbox value={settings.hidden_blocked} id="hidden_blocked" onChange={updateAccountSetting} label="Hide profile from members I have blocked." />
              <Checkbox value={settings.hidden_favorite} id="hidden_favorite" onChange={updateAccountSetting} label="Hide my profile from user's &quot;favorited you&quot; list." />
              <Checkbox value={settings.hidden_view} id="hidden_view" onChange={updateAccountSetting} label="Hide my profile in user's &quot;viewed me&quot; list." />
              <Checkbox value={settings.hidden_last_login_dt} id="hidden_last_login_dt" onChange={updateAccountSetting} label="Hide my last login date" />
            </InputGroup>
          </Container>
      </div>
    );
  }
}

export default ManagePrivacy;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/ManagePrivacy.jsx